<ion-app>
  <!-- Entete de l'application -->
  <app-entete></app-entete>

  <!-- Composant gérés par le router-->
  <ion-content>
    <ion-router-outlet></ion-router-outlet>
  </ion-content>
</ion-app>